import React from 'react';
import DeliveryImg from '|/app/purchase/cart/steps/transfer-method/assets/have-it-delivered.png';
import PickupImg from '|/app/purchase/cart/steps/transfer-method/assets/vm-experience.jpg';
import styles from './AddressDisplay.module.css';
import { useOrderSummaryContext } from '../../contexts/orderSummary';
import { getTransferTypeNormalized } from '../../utils/transferHelpers';

export const AddressDisplay = () => {
  const {
    state: {
      orderSummary: { transfer }
    }
  } = useOrderSummaryContext();
  const { line1: addressLine1 = '', city = '', state = '', zipCode = '' } = transfer?.address ?? {};
  const transferType = getTransferTypeNormalized(transfer);
  const isPickup = transferType === 'pickup';
  const label = isPickup ? 'Picking up from' : 'Delivering to';
  const image = isPickup ? PickupImg : DeliveryImg;

  return (
    <div className={styles.container}>
      <div className={styles.imageWrapper}>
        <img className={styles.image} src={image} alt={label} />
      </div>
      <div className={styles.content}>
        <p className={styles.label}>{label}</p>
        <div className={styles.address}>
          <p className={styles.addressText}>{addressLine1}</p>
          <p className={styles.addressText}>
            {city}, {state} {zipCode}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AddressDisplay;
